import { useIntl } from "react-intl";
import { cn } from "../utils/tailwind";

interface DefaultProfilePicProps {
  alt: string;
  className?: string | undefined;
}

function DefaultProfilePic({ alt, className }: DefaultProfilePicProps) {
  const intl = useIntl();
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 600"
      width="100%"
      height="100%"
      className={cn(className, "fill-white")}
      aria-description={intl.formatMessage({
        defaultMessage: "Default user icon",
      })}
    >
      <title>{alt}</title>
      <clipPath id="border">
        <circle cx="300" cy="300" r="300" />
      </clipPath>
      <circle cx="300" cy="300" r="300" className="fill-brand-500" />
      <circle cx="300" cy="230" r="115" />
      <circle cx="300" cy="550" r="205" clipPath="url(#border)" />
    </svg>
  );
}

interface Props {
  src?: string;
  className?: string;
  alt: string;
}

export default function ProfilePic({ src, alt, className }: Props) {
  if (src) {
    return (
      <img
        className={cn(
          "w-full rounded-full object-cover object-center bg-transparent shadow-xs",
          className,
        )}
        src={src}
        alt={alt}
      />
    );
  } else {
    return (
      <DefaultProfilePic
        alt={alt}
        className={cn("rounded-full shadow-xs h-fit", className)}
      />
    );
  }
}
